import React from 'react';
import classNames from 'classnames/bind';
import Empty from "../../../assets/images/Emty.png";
import styles from './NoData.module.css'

const cx = classNames.bind(styles)
const Nodata = () => {
    return (
        <div className={cx("no-data")}>
        <div style={{display:"flex",flexDirection:"column",alignItems:"center"}}>
          {" "}
          <img src={Empty} />
          <p className={cx("description")}>Không có dữ liệu</p>
        </div>
      </div>
    );
};

export default Nodata;